import React from 'react';
import {
    Box,
    TextInput,
    Text,
    Button,
    CheckBox,
    ResponsiveContext,
} from "grommet";
import { isMobile } from 'react-device-detect';
import AutoComplete from 'react-google-autocomplete';
import ReactGoogleAutocomplete, { usePlacesWidget } from "react-google-autocomplete";
import ClickableCards from '../../elements/clickable_card';
import { CIVILITY } from '../../../services/types';
import CustomInput from '../../elements/custom_input';
import AddressInfo from '../../elements/address';
import translate from '../../../i18n/translate';
import LineBox from '../../responsive/line_container';


const ClientInfo = ({ client, onDevisChange }) => {

    const onClientInfoChange = (field, value) => {
        client[field] = value;
        onDevisChange('client', client);
    }

    return (
        <ResponsiveContext.Consumer>
            {size => (
                <Box align='center' justify='center' gap='small' pad={'small'}>
                    <Box width={'large'} gap='small'>
                        <Text>{translate('votre_information')}</Text>
                        <LineBox
                            size={size}
                            leftText={translate('civilite')}
                            rightChild={
                                <ClickableCards
                                    size={size}
                                    cards={
                                        Object.keys(CIVILITY).map(key => ({
                                            title: translate(key),
                                            selected: client.civilite === CIVILITY[key],
                                            onClick: () => onClientInfoChange('civilite', CIVILITY[key])
                                        }))
                                    }
                                />
                            }
                        />
                        {client.civilite === CIVILITY.societe &&
                            <Box gap='small'>
                                <LineBox
                                    size={size}
                                    leftText={translate('raison_social')}
                                    rightChild={
                                        <CustomInput
                                            value={client.raison_social}
                                            onChange={event => onClientInfoChange('raison_social', event.target.value)}
                                        />
                                    }
                                />
                                <LineBox
                                    size={size}
                                    leftText={translate('prenom_representant')}
                                    rightChild={
                                        <CustomInput
                                            value={client.firstname}
                                            onChange={event => {
                                                onClientInfoChange('firstname', event.target.value);
                                            }}
                                        />
                                    }
                                />
                                <LineBox
                                    size={size}
                                    leftText={translate('nom_representant')}
                                    rightChild={
                                        <CustomInput
                                            value={client.lastname}
                                            onChange={event => {
                                                onClientInfoChange('lastname', event.target.value);
                                            }}
                                        />
                                    }
                                />
                            </Box>
                        }

                        {client.civilite !== CIVILITY.societe &&
                            <Box gap='small'>
                                <LineBox
                                    size={size}
                                    leftText={translate('prenom')}
                                    rightChild={
                                        <CustomInput
                                            value={client.firstname}
                                            onChange={event => onClientInfoChange('firstname', event.target.value)}
                                        />
                                    }
                                />
                                <LineBox
                                    size={size}
                                    leftText={translate('nom')}
                                    rightChild={
                                        <CustomInput
                                            value={client.lastname}
                                            onChange={event => onClientInfoChange('lastname', event.target.value)}
                                        />
                                    }
                                />
                            </Box>
                        }
                        <LineBox
                            size={size}
                            leftText={translate('address_mail')}
                            rightChild={
                                <CustomInput
                                    value={client.email}
                                    onChange={event => onClientInfoChange('email', event.target.value)}
                                />
                            }
                        />
                        <LineBox
                            size={size}
                            leftText={translate('phone')}
                            rightChild={
                                <CustomInput
                                    value={client.phone}
                                    onChange={event => onClientInfoChange('phone', event.target.value)}
                                />
                            }
                        />

                        <AddressInfo
                            devis={client}
                            onDevisChange={onClientInfoChange}
                            placeField={{
                                address: 'address',
                                city: 'city',
                                zip: 'zip'
                            }}
                            title={translate('indiquer_adresse')}
                        />
                    </Box>
                </Box>
            )}
        </ResponsiveContext.Consumer>
    )
}

export default ClientInfo;